import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import withStyles from '@material-ui/core/styles/withStyles';

export const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    paddingLeft: '0',
  },
}))(MenuItem);


export const StyledListItemIcon= withStyles((theme) => ({
  root: {
    minWidth: '30px',
    paddingRight: '10px',
  },
}))(ListItemIcon);
